import './carousel-stories.css'
import './index.css'

import './all-filters.js'
import './carousel-hero.js'
import './carousel-linha.js'
import './carousel-stories.js'
import './carousel-team.js'
import './menu.js'
import './more-categories.js'
import './on-scroll.js'
import './quiz.js'
import './search.js'
import './segredos-free-from.js'
import './select.js'
import './single-product.js'
import './user-location.js'
